import { Appearance, PrintArea } from '@/types';
import { getPrintTypesForPrintArea } from './getPrintTypesForPrintArea';
import { isDigital } from './isDigital';
import { PrepunchedEmbroideryPixel, ScreenPrint } from './printTypes';

const DIGITAL_PRINT_TYPES_WITHOUT_SPECIAL_TEXT = new Set([ScreenPrint, PrepunchedEmbroideryPixel]);

export const printTypesForSpecialText = (printArea: PrintArea, appearance: Appearance) =>
  getPrintTypesForPrintArea(printArea, appearance).filter(
    (printType) =>
      isDigital(printType) && !DIGITAL_PRINT_TYPES_WITHOUT_SPECIAL_TEXT.has(printType.id)
  );
